import { ServiceFactory } from "../ServiceFactory";

// Export the abstraction, not the implementation
export const onlineOrdersService = ServiceFactory.getOnlineOrdersService();

// Export implementations and types for consumers
export type { IOnlineOrdersService } from "./IOnlineOrdersService";
export { OnlineOrdersService } from "./OnlineOrdersService";
export { OnlineOrdersServiceMock } from "./OnlineOrdersServiceMock";
